import React,{useEffect} from "react";
import "./LoanAgreement.css";
import { Grid } from "@mui/material";
import Proptypes from "prop-types";
import { ImageBaseUrl } from "../../Environment";
import moment from "moment";
import { getSecureItem } from "../../utilsFunctions";
import { SignatureLabels } from "../../Constants/SignatureLabels";

const tableStaticData = [];

export const LoanAgreement = ({ branchAddress = null, data, printRef, noOfLoans, language, signatureType }) => {
  const countryCode = getSecureItem("country")?.code;
  const countryCurrency = getSecureItem("country")?.symbol;

  const companyData = data?.company;
  const userData = data?.user;
  const customerData = data?.customer;
  const customerDataAddresses = data?.customer?.addresses[0];
  const customerDataBankDetail = data?.customer?.bankDetail;
  const customerDataCoApplicant = data?.customer?.coApplicant;
  const customerDataNominee = data?.customer?.nominee;
  const customerDataGuarantor = data?.customer?.guarantor;
  const customerDataLoanType = data?.loanType;
  const customerProfilePic = data?.customer?.proofs?.find(p => p.proofType === "profilepic")?.proofImagePath;
  const customerSignaturePic = data?.customer?.proofs?.find(p => p.proofType === "uploadSignature")?.proofImagePath;
  const AdminSignature =
    companyData?.users?.find(
      u =>
        u.userType === "Admin" &&
        u.branchId === data?.customer?.branchId &&
        u.userSignaturePath
    )?.userSignaturePath ||
    companyData?.users?.find(
      u => u.userType === "superAdmin" && u.userSignaturePath
    )?.userSignaturePath ||
    null;

  const loanCollections = data?.loanCollections;
  const firstLoanCollection = data?.loanCollections[0];

      useEffect(() => {
      const customerName = `${customerData?.firstName ?? ""} ${customerData?.lastName ?? ""}`.trim();
      document.title = `Loan Agreement - ${customerName || "Customer"}`;
  
      return () => {
        document.title = "LendStack - Forging Digital OneOffice for Micro Business";
      };
    }, [customerData]);

  const {
    loanTenureType,
    loanTenure,
    processFee,
    feeDetailsJson,
    collectionAmount,
    loanAmount,
    totalAmountToCollect,
    loanId,
    method,
  } = data;
  console.log("data", data);  

  const getAddress = (address) =>
    [
      address?.AddressStreet,
      address?.AddressLandmark,
      address?.AddressCity,
      address?.AddressState,
      address?.AddressPincode,
    ]
      .filter(Boolean)
      .join(", ");

  const customerAddress = (address) =>
    [address?.AddressStreet, address?.AddressLandmark]
      .filter(Boolean)
      .join(", ");

  const customerAddress2 = (address) =>
    [address?.AddressCity, address?.AddressState, address?.AddressPincode]
      .filter(Boolean)
      .join(", ");
  return (
    <div ref={printRef} className="loan-agreement">
      <Grid container>
        <Grid
          item
          xs={12}
          sm={2}
          md={2}
          paddingX={2}
          style={{ border: "1px solid black" }}
        >
          <div className="header-left">
            {companyData?.profilePic ? (
              <img
                src={
                  getSecureItem("loggedinUserCompany") == "1365"
                    ? "https://i.imghippo.com/files/CCD2780qQ.jpeg"
                    : `${ImageBaseUrl}${companyData?.profilePic}`
                }
                alt="Logo"
                className="logo"
              />
            ) : (
              <div
                style={{
                  height: "120px",
                }}
              ></div>
            )}
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={8}
          md={8}
          paddingX={2}
          style={{ border: "1px solid black", borderRightWidth: "0px" }}
        >
          <div className="header-right">
            <h1>{companyData?.companyName}</h1>
            <p>
              <strong>Address: </strong> {branchAddress ? branchAddress : getAddress(companyData)}
              <br />
              <strong>GSTIN: </strong> {companyData?.GstIn || ""} |{" "}
              <strong>CIN: </strong> {companyData?.CIN || ""} |{" "}
              <strong>Website: </strong> {companyData?.companyWebsite || ""}
              <br />
              <strong>Mobile No: </strong> {companyData?.phone}{" "}
              <strong>| Email ID: </strong> {companyData?.companyMail}
            </p>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={2}
          md={2}
          paddingX={2}
          style={{ border: "1px solid black", borderLeftWidth: "0px" }}
        />
      </Grid>
      <h2 className="title">Loan Agreement</h2>
      <div style={{marginBottom: 10}} align="right">
        <span className="Fonts">All amounts are in {countryCurrency}.</span>
      </div>
      <div className="content">
        <div className="section">
          <table className="info-table">
            <tbody>
              <tr>
                <td colspan={2}>
                  <strong>Branch : </strong> <br />{" "}
                  <strong>Branch Center : </strong>
                </td>
                <td colspan={2}>
                  <strong>Date : </strong>
                  {moment().format("DD-MM-YYYY")} |{" "}
                  <strong>First EMI Date : </strong>
                  {moment(firstLoanCollection?.dueDate || new Date()).format("DD-MM-YYYY")}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Customer Name</strong> <br />{" "}
                  {customerData?.firstName + ` (${customerData?.cust_id})`}
                </td>
                <td>
                  <strong>Address</strong> <br />{" "}
                  {customerAddress(customerDataAddresses)}
                </td>
                <td>
                  <strong>District/State</strong> <br />{" "}
                  {customerAddress2(customerDataAddresses)}
                </td>
                <td rowSpan={3}>
                  <div className="imgBox">
                    {customerProfilePic && (
                      <img
                        src={`${ImageBaseUrl}${customerProfilePic}`}
                        alt="Customer"
                        className="profileImg"
                      />
                    )}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Contact No</strong> <br /> {customerData?.phone}
                </td>
                <td>
                  <strong>Gender : </strong> {customerData?.gender}
                  <br /> <strong>DOB : </strong>
                  {customerData?.dob && moment(customerData?.dob).format("DD-MM-YYYY")}
                </td>
                <td>
                  <strong>C/O</strong> <br /> {customerData?.fatherName}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Co-Applicant : </strong> <br />{" "}
                  {customerDataCoApplicant?.coApplicantName}
                </td>
                <td>
                  <strong>Co-Applicant Address : </strong> <br />{" "}
                  {customerDataCoApplicant?.coApplicantAddress}
                </td>
                <td>
                  <strong>Co-Applicant Phone : </strong> <br />{" "}
                  {customerDataCoApplicant?.coApplicantMobNo}
                </td>
              </tr>
              <tr>
                <td colspan={2}>
                  <h3>Bank Details</h3>
                </td>
                <td colspan={2}>
                  <h3>Applied Loan Details</h3>
                </td>
              </tr>

              <tr>
                <td>Bank : {customerDataBankDetail?.bankName}</td>
                <td>Branch : {customerDataBankDetail?.bankBranch}</td>
                <td>Loan ID : {loanId}</td>
                <td>Processing Fee : {processFee}</td>
              </tr>
              <tr>
                <td>
                  Account Number : {customerDataBankDetail?.accountNumber}
                </td>
                <td>Account Type : {customerDataBankDetail?.accountType}</td>
                <td>
                  Amount to be Paid :{" "}
                  {totalAmountToCollect}
                </td>
                <td>
                  Additional Fee
                  {feeDetailsJson &&
                    Object.entries(feeDetailsJson)
                      .filter(([key]) => key !== "totalFee")
                      .map(([key, value]) => (
                        <div key={key}>
                          {key}: {countryCurrency} {value}
                        </div>
                      ))}
                </td>
              </tr>
              <tr>
                <td>Account Holder : {customerDataBankDetail?.acHolderName}</td>
                <td>IFSC : {customerDataBankDetail?.ifsc}</td>
                <td>Loan Amount : {loanAmount}</td>
                <td>Interest Amount : {Number(totalAmountToCollect)-loanAmount}</td>
              </tr>
              <tr>
                <td colspan={2}>
                  <h3>Income Details</h3>
                </td>
                <td>Loan Type : {customerDataLoanType?.loanType}</td>
                <td>Installment Amount : {collectionAmount}</td>
              </tr>

              <tr>
                <td>Income : {customerData?.annualIncome}</td>
                <td>Occupation : {customerData?.incomeSource}</td>
                <td>Recovery type : {loanTenureType}</td>
                <td>No of Payments : {loanTenure}</td>
              </tr>
              <tr>
                <td colspan={3}>
                  <h3>Guarantor Details</h3>
                </td>
                <td rowSpan={3}>
                  <div className="imgBox" />
                </td>
              </tr>
              <tr>
                <td>Name : {customerDataGuarantor?.guarantorName}</td>
                <td>Address : {customerDataGuarantor?.guarantorAddress}</td>
                <td>
                  Contact Number : {customerDataGuarantor?.guarantorMobNo}
                </td>
              </tr>
              {getSecureItem("loggedinUserCompany") === "3310" ? null : (<tr>
                <td>Nominee Name : {customerDataNominee?.nomineeName}</td>
                <td>Nominee Mobile : {customerDataNominee?.nomineeMobNo}</td>
                <td>
                  Nominee DOB :{" "}
                  {moment(customerDataNominee?.nomineeDOB).format("DD-MM-YYYY")}
                </td>
              </tr>)}
            </tbody>
          </table>
        </div>

        <div className="footer section">
          <table
            className="footer-table"
            style={{ width: "100%", borderCollapse: "collapse" }}
          >
            <tbody>
              <tr>
                <td style={{ border: "1px solid black", textAlign: "center" }}>
                  {countryCode == '91' ? 
                    <strong>
                      {SignatureLabels.memberSignature.en}
                      <br />
                      {SignatureLabels.memberSignature[language]}
                    </strong> :
                    <strong> {SignatureLabels.memberSignature.en}
                    </strong>}
                  <br />
                  {signatureType && customerSignaturePic ? (
                    <img src={`${ImageBaseUrl}${customerSignaturePic}`} alt="Member Signature" style={{ maxWidth: "100%", maxHeight: "60px", objectFit: "contain", marginTop: 10 }} />
                  ) : (
                    <span style={{ marginTop: 30 }} className="input-line"></span>
                  )}
                </td>
                <td style={{ border: "1px solid black", textAlign: "center" }}>
                  {countryCode == '91' ?
                    <strong>
                      {SignatureLabels.guarantorSignature.en}
                      <br />
                      {SignatureLabels.guarantorSignature[language]}
                    </strong> :
                    <strong> {SignatureLabels.guarantorSignature.en}
                    </strong>}
                  <br />
                  <span style={{ marginTop: 30 }} className="input-line"></span>
                </td>
                <td style={{ border: "1px solid black", textAlign: "center" }}>
                  {countryCode == '91' ?
                    <strong>
                      {SignatureLabels.branchSealSignature.en}
                      <br />
                      {SignatureLabels.branchSealSignature[language]}
                    </strong> :
                    <strong> {SignatureLabels.branchSealSignature.en}
                    </strong>}
                  <br />
                  {signatureType && AdminSignature ? (
                    <img src={`${ImageBaseUrl}${AdminSignature}`} alt="Authorized Signature" style={{ maxWidth: "100%", maxHeight: "60px", objectFit: "contain", marginTop: 10 }} />
                  ) : (
                    <span style={{ marginTop: 30 }} className="input-line"></span>
                  )}
                </td>
                <td style={{ border: "1px solid black", textAlign: "center" }}>
                  {countryCode == '91' ?
                    <strong>
                      {SignatureLabels.companySealSignature.en}
                      <br />
                      {SignatureLabels.companySealSignature[language]}
                    </strong> :
                    <strong> {SignatureLabels.companySealSignature.en}
                    </strong>}
                  <br />
                  {signatureType && companyData?.signature ? (
                    <img src={`${ImageBaseUrl}${companyData?.signature}`} alt="Authorized Signature" style={{ maxWidth: "100%", maxHeight: "60px", objectFit: "contain", marginTop: 10 }} />
                  ) : (
                    <span style={{ marginTop: 30 }} className="input-line"></span>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* New page break */}
        <div className="page-break"></div>

        <div className="section">
          <h2 className="title">Repayment Schedule Terms</h2>

          <table className="info-table compact-table">
            <thead>
              <th>Sr. No</th>
              <th>EMI Date</th>
              {method == "Collection method" ? (
                <>
                  <th>Opening Balance</th>
                  <th>Closing Balance</th>
                </>
              ) : (
                <>
                  <th>Opening Balance</th>
                  <th>Closing Balance</th>
                  <th>Interest</th>
                  <th>Principal</th>
                </>
              )}
              <th>Installment</th>
            </thead>
            <tbody>
              {loanCollections?.map((data, i) => {
                const totalRows = loanCollections.length;
                const maxPageBreaks = Math.floor(totalRows / noOfLoans); // Calculate the maximum number of page breaks
                return (
                  <React.Fragment key={data?.srNo}>
                    <tr>
                      <td style={{ width: "10%" }}>{i + 1}</td>
                      <td style={{ width: "30%" }}>
                        {moment(data?.dueDate).format("DD-MM-YYYY")}
                      </td>
                      {method == "Collection method" ? (
                        <>
                          <td style={{ width: "20%" }}>
                            {data?.openingBalance}
                          </td>
                          <td style={{ width: "20%" }}>
                            {data?.closingBalance}
                          </td>
                        </>
                      ) : (
                        <>
                          <td style={{ width: "10%" }}>
                            {data?.openingBalance}
                          </td>
                          <td style={{ width: "10%" }}>
                            {data?.closingBalance}
                          </td>
                          <td style={{ width: "10%" }}>{data?.interest}</td>
                          <td style={{ width: "10%" }}>{data?.principal}</td>
                        </>
                      )}
                      <td style={{ width: "20%" }}>{data?.Installment}</td>
                    </tr>
                    {(i + 1) % noOfLoans === 0 &&
                      (i + 1) / noOfLoans <= maxPageBreaks &&
                      i + 1 < totalRows && <tr className="page-break"></tr>}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
    {countryCode == '91' && (
      <>
        {language === "ta" && <div className="page-break"></div>}

        {language === "ta" && <div className="section">
          <h2 className="title">விதிமுறைகள் மற்றும் நிபந்தனைகள்</h2>

          <ol style={{ fontSize: "14px" }}>
            <li> மேலே குறிப்பிடப்பட்டுள்ள அனைத்து தரப்பினரும் பின்வரும் விதிமுறைகள் மற்றும் நிபந்தனைகளுக்கு தங்களது சம்மதத்தை தெரிவிக்கிறார்கள். கடனாளி இக்கடன் தொகையை மைக்ரோஃபைனான்ஸ் விதிமுறைகளைப் புரிந்து கொண்டு பயன்படுத்த வேண்டும். இந்தத் தொகையையோ அதன் எந்தப் பகுதியையோ, அனுமதிக்கப்படாத பிற நோக்கங்களுக்கு பயன்படுத்தக்கூடாது. நிபந்தனைகள் பின்பற்றப்படவில்லை என்பதை நிறுவனம் கண்டறிந்தால், நிறுவனம் எந்த வித தளர்வும் இன்றி முழு கடன் தொகையையோ அதன் எந்தப் பகுதியையோ திரும்பப் பெறும் அதிகாரம் கொண்டது. </li>
            <li> நான்/நாங்கள், கடனுக்கு விண்ணப்பித்தவர்கள் மற்றும் உத்தரவாதம் அளிப்பவர்கள், இதற்கு முன்பு எந்த சட்டவிரோத செயலிலும் ஈடுபட்டதில்லை. எங்களிடம் எதிராக எந்த நீதிமன்றத்திலும் குற்றவியல் வழக்கு நிலுவையில் இல்லை, மேலும் எந்த காவல் நிலையத்திலும் எங்கள்மீது எப்.ஐ.ஆர் பதிவாகவில்லை. </li>
            <li> நான்/நாங்கள் எந்த வங்கி, நிதி நிறுவனம் அல்லது ஃபைனான்ஸ் கம்பெனியால் டிஃபால்ட்டராக அறிவிக்கப்பட்டதில்லை. </li>
            <li> நான்/நாங்கள் இந்தக் கடனின் முழு தவணைகளையும் செலுத்தக்கூடிய திறன் கொண்டவர்கள். எந்தவொரு எதிர்மறை சூழ்நிலையிலும் கூட நான்/நாங்கள் தவணை செலுத்துவதில் தாமதம் செய்யமாட்டோம். </li>
            <li> நிறுவனத்தின் தவணை தொகையை வசூலிக்க வரும் எந்த ஊழியருடனும் நான்/நாங்கள் மரியாதையாக நடத்திக்கொள்வோம். அவரிடம் எந்தவொரு தவறான அல்லது கேவலமான வார்த்தைகளையும் பேசமாட்டோம். அவருக்குக் கேடு விளைவிக்க, தாக்குதல் செய்ய முயற்சிக்க மாட்டோம். எங்களால் ஏதேனும் தவறான நடத்தை நிகழ்ந்தால், அந்த ஊழியரும் நிறுவனமும் எங்கள்மீது சட்ட நடவடிக்கை எடுக்கத் தாராளம். </li>
            <li> தவணைகள் தொடர்பான நினைவூட்டல், அறிவிப்பு, ரிமைண்டர், அல்லது எலக்ட்ரானிக் தகவல் வழங்குவதற்கு நிறுவனம் பொறுப்பல்ல. தவணை தேதியை நினைவில் வைத்திருப்பது முழுமையாக என்/எங்களின் பொறுப்பாகும். </li>
            <li> கடனாளி அல்லது உத்தரவாதம் அளிப்பவர் தமது தொழில், வேலை, முகவரி, மொபைல் எண் அல்லது மின்னஞ்சல் ஐடியை மாற்றினால், அதை முறையாக எழுத்துப்பூர்வமாக நிறுவனத்திற்கு முன்கூட்டியே தெரிவிக்க வேண்டும். </li>
            <li> நான்/நாங்கள் எதிர்காலத்தில் தவணைகளை காசோலை மூலம் செலுத்தினால், வழங்கப்பட்ட காசோலைகளை வங்கியில் ஸ்டாப் செய்யமாட்டோம், அவை தொலைந்ததாக புகார் அளிக்கமாட்டோம், அல்லது அந்த வங்கி கணக்கை மூடமாட்டோம். இவற்றில் ஏதேனும் செய்முறைகள் மேற்கொள்ளப்பட்டால், நிறுவனம் எங்கள்மீது சட்ட நடவடிக்கை எடுக்கலாம். </li>
            <li> நிறுவனம் வசூலிப்பதற்காக வழங்கும் எஸ்.எம்.எஸ், கால், மெயில், நோட்டீஸ் போன்ற சேவைகளுக்கான எந்த சர்வீஸ் சார்ஜும் கேட்டால், அதை நாங்கள் செலுத்த ஒப்புக்கொள்கிறோம். </li>
            <li> இந்த ஒப்பந்தத்தின் படி உத்தரவாதம் அளிப்பவரின் முழு பொறுப்பும் கடமையும் நிலைநிற்கும். எதிர்காலத்தில் கடனாளிக்கு விபத்து, மரணம், திவால் நிலை அல்லது கடும் நோய் ஏற்பட்டால், முழு கடனையும் உத்தரவாதம் அளிப்பவர் செலுத்த வேண்டும். </li>
            <li> நான்/நாங்கள் நிறுவனத்திற்கு அளித்த அனைத்து தகவல்களும் வாய்மொழியாக வழங்கப்பட்டவை, அவை அனைத்தும் உண்மையானவை. எந்த தவறான தகவலும் அளிக்கப்படவில்லை. தவறான தகவல் இருப்பது கண்டறியப்பட்டால், நிறுவனம் எங்கள்மீது சட்ட நடவடிக்கை எடுக்கலாம். வட்டி, தவணை தொகை, தவணை நேரம், செலுத்தும் முறைகள் அனைத்தையும் நாங்கள் முழுமையாக புரிந்துகொண்டுள்ளோம். நிறுவன ஊழியர் இதுகுறித்து முழுமையாக விளக்கியுள்ளார். இந்த விதிமுறைகள் அனைத்துக்கும் நான்/நாங்கள் முழுமையாக தயாராக இருக்கிறோம். தவணை செலுத்த தாமதித்தால், கூடுதல் கட்டணம், சட்ட செலவு, காகித செலவு, விஜிட் செலவு முதலிய அனைத்தும் எங்களால் செலுத்தப்படும். </li>
            <li> நான்/நாங்கள் வழங்கிய ஆதார், பான், ரேஷன் கார்டு, டிரைவிங் லைசன்ஸ், வங்கி பாஸ்புக் மற்றும் புகைப்படம் உள்ளிட்ட எந்த ஆவணங்களிலும் மாற்றம் செய்யப்படவில்லை, போலி ஆவணங்களும் வழங்கப்படவில்லை. எதிர்காலத்தில் ஏதேனும் ஆவணம் போலியானது எனத் தெரிய வந்தால், 420 பிரிவு கீழ் எங்கள்மீது வழக்கு பதிவு செய்யப்படலாம் என்பதை நாங்கள் முன்கூட்டியே அறிகிறோம். </li>
            <li> நான்/நாங்கள் எங்கள் தவணைகளை தினசரி/வாராந்திர/இருவாராந்திர/மாதாந்திர முறையில் செலுத்த விரும்புகிறோம். </li>
            <li> இந்தக் கடன் செலுத்துதல், நிலுவைத் தொகை அல்லது ஏதேனும் சிறப்பு செயல்பாடுகளுக்காக நிறுவனம் எப்போது அழைத்தாலும், நான்/நாங்கள் காலத்திற்கு ஏற்றபடி வருவோம். </li>
            <li> என் வருடாந்திர வருமானம் {countryCurrency}300000-இற்குக் குறைவானது. இந்த ஒப்பந்தத்தை அல்லது கடனைச் செய்யும் நேரத்தில் நாங்கள் எந்த வகையான மயக்கப்பொருளும் பயன்படுத்தவில்லை. முழு உணர்வுடனும் புத்திசாலித்தனத்துடனும் இவ்வொப்பந்தத்தில் கையெழுத்திடுகிறோம். </li>
            <li> எதிர்காலத்தில் நாங்கள் தவணையை நேரத்தில் செலுத்தவில்லை என்றால், நிறுவனம் எங்கள்மீது சட்ட நடவடிக்கை எடுக்கலாம், இதில் எனக்கு எந்த எதிர்ப்பும் இல்லை. </li>
            <li> நாங்கள் தவணையை நேரத்தில் செலுத்தவில்லை அல்லது டிஃபால்ட்டராக இருந்தால், நிறுவனம் எங்கள் சிபில் பதிவில் இதைச் சேர்க்கும் உரிமை கொண்டுள்ளது. </li>
          </ol>
        </div>}

        {language === "te" && <div className="page-break"></div>}

        {language === "te" && <div className="section">
          <h2 className="title">నియమాలు మరియు షరతులు</h2>

          <ol style={{ fontSize: "14px" }}>
            <li> పై పేర్కొన్న అన్ని పక్షాలు క్రింది నిబంధనలు మరియు షరతులను అంగీకరిస్తున్నారని తెలియజేస్తున్నారు. రుణగ్రహీత ఈ రుణాన్ని మైక్రో ఫైనాన్స్ నియమావళి ప్రకారం మాత్రమే ఉపయోగించాలి. అనుమతి లేని ఇతర ప్రయోజనాలకు ఈ మొత్తం లేదా దాని ఏభాగమును ఉపయోగించరాదు. నిబంధనలు పాటించలేదని కంపెనీ కనుగొంటే, కంపెనీకి ఈ రుణ మొత్తం లేదా దాని ఏ భాగాన్నైనా ఎటువంటి రాయితీ లేకుండా తిరిగి తీసుకునే హక్కు ఉంది. </li>
            <li> నేను/మేము, రుణానికి దరఖాస్తు చేసిన వారు మరియు గ్యారంటీ ఇచ్చే వారు, గతంలో ఏవైనా చట్ట విరుద్ధ కార్యకలాపాలలో పాల్గొనలేదు. మా పై ఏ కోర్టులోనూ క్రిమినల్ కేసు పెండింగ్‌లో లేదు, ఏ పోలీస్ స్టేషన్‌లోనూ ఎఫ్‌ఐఆర్ నమోదు కాలేదు. </li>
            <li> నేను/మేము ఏ ఆర్థిక సంస్థ, బ్యాంక్ లేదా ఫైనాన్స్ కంపెనీ చేత డిఫాల్టర్‌గా ప్రకటించబడలేదు. </li>
            <li> నేను/మేము ఈ రుణానికి సంబంధించిన అన్ని వాయిదాలను చెల్లించే సామర్థ్యం కలిగి ఉన్నాం. ప్రతికూల పరిస్థితులలో కూడా వాయిదా చెల్లింపులో ఆలస్యం చేయము. </li>
            <li> మా వాయిదా మొత్తం వసూలు చేయడానికి వచ్చే కంపెనీ ఉద్యోగితో నేను/మేము గౌరవంగా మాట్లాడతాం. అతనికి ఎటువంటి అసభ్యమైన లేదా అనుచితమైన మాటలు చెప్పము. అతనికి హాని చేయడానికి, దాడి చేయడానికి ప్రయత్నించము. మా వల్ల ఏదైనా అవినీతిపూరిత ప్రవర్తన జరిగితే, కంపెనీ మరియు ఉద్యోగికి మా పై చట్టపరమైన చర్యలు తీసుకునే హక్కు ఉంటుంది. </li>
            <li> వాయిదా తేదీ గురించి గుర్తు చేసే బాధ్యత కంపెనీది కాదు. నోటిస్, రిమైండర్, ఎలక్ట్రానిక్ సమాచారాలు, ఫోన్ కాల్స్ ఇవ్వడం కంపెనీ బాధ్యత కాదు. వాయిదా తేదీ గుర్తుంచుకోవడం పూర్తిగా నా/మా బాధ్యత. </li>
            <li> రుణగ్రహీత లేదా గ్యారంటీ ఇచ్చేవారు తమ వ్యాపారం, ఉద్యోగం, శాశ్వత చిరునామా, మొబైల్ నంబర్ లేదా ఇమెయిల్ ఐడీ మార్చినట్లయితే, ముందుగానే లిఖితపూర్వకంగా కంపెనీకి సమాచారం ఇవ్వాలి. </li>
            <li> భవిష్యత్తులో మేము వాయిదాలను చెక్కుల ద్వారా చెల్లించినట్లయితే, ఇచ్చిన చెక్కులను బ్యాంకులో స్టాప్ చేయము, అవి పోయినట్లు పోలీసులకు ఫిర్యాదు చేయము, లేదా ఆ బ్యాంకు ఖాతాను మూసివేయము. అలా చేస్తే కంపెనీ మా పై చట్టపరమైన చర్యలు తీసుకునే హక్కు కలిగి ఉంటుంది. </li>
            <li> కంపెనీ వసూలు కోసం అందించే SMS, కాల్స్, మెయిల్, నోటీసు లాంటి సేవల కోసం కోరే ఏ సేవా రుసుము అయినా మేము చెల్లిస్తాము. </li>
            <li> ఈ ఒప్పందం ప్రకారం గ్యారంటీ ఇచ్చే వ్యక్తికి పూర్తిగా బాధ్యత ఉంటుంది. భవిష్యత్తులో రుణగ్రహీతకు ప్రమాదం, మరణం, దివాలా లేదా తీవ్రమైన అనారోగ్యం వంటి సంఘటనలు జరిగితే, మొత్తం రుణాన్ని గ్యారంటీ ఇచ్చే వ్యక్తి చెల్లించాలి. </li>
            <li> నేను/మేము కంపెనీకి ఇచ్చిన సమాచారం మొత్తం నిజమైనదే. ఎటువంటి తప్పుడు సమాచారం ఇవ్వలేదు. ఏదైనా తప్పుడు సమాచారం ఉన్నట్లు తేలితే, కంపెనీకి మా పై చట్టపరమైన చర్యలు తీసుకునే హక్కు ఉంది. వడ్డీ, వాయిదా మొత్తం, వాయిదా సమయం మొదలైన విషయాలను నేను/మేము పూర్తిగా అర్థం చేసుకున్నాం. కంపెనీ ఉద్యోగి మాకు అన్ని వివరాలను వివరించారు. ఈ నిబంధనలు మరియు షరతులను నేను/మేము పూర్తిగా అంగీకరిస్తున్నాం. వాయిదా చెల్లింపులో ఆలస్యం జరిగితే, అదనపు ఛార్జీలు, లీగల్ ఖర్చులు, పేపర్ ఖర్చులు, సందర్శన ఖర్చులు మొదలైనవి మేమే చెల్లిస్తాం. </li>
            <li> నేను/మేము అందించిన ఆధార్ కార్డు, పాన్ కార్డు, రేషన్ కార్డు, డ్రైవింగ్ లైసెన్స్, బ్యాంక్ పాస్‌బుక్, ఫోటోలు మొదలైనఏ డాక్యుమెంట్‌లో కూడా మార్పులు చేయలేదు. ఏదైనా డాక్యుమెంట్ నకిలీ అని భవిష్యత్తులో తేలితే, కంపెనీ 420 సెక్షన్ కింద కేసు పెట్టవచ్చని మేము ముందుగానే అర్థం చేసుకున్నాం. </li>
            <li> నేను/మేము వాయిదాలను దినసరి/వారానికొకసారి/పదిహేనురోజులకు ఒకసారి/నెలసరి పద్ధతిలో చెల్లించదలచుకున్నాం. </li>
            <li> ఈ రుణం చెల్లింపులు, బ్యాలెన్స్ ధృవీకరణ లేదా ఇతర ప్రత్యేక కార్యక్రమాల కోసం కంపెనీ పిలిస్తే, నేను/మేము సరైన సమయంలో హాజరవుతాం. </li>
            <li> నా వార్షిక ఆదాయం {countryCurrency}300000 కంటే తక్కువ. ఈ ఒప్పందం చేసేటప్పుడు మేము ఏ మత్తు పదార్థాలూ తీసుకోలేదు. పూర్తిగా స్పష్టమైన మానసిక స్థితిలోనే ఈ ఒప్పందం చేస్తున్నాం. </li>
            <li> భవిష్యత్తులో నేను/మేము వాయిదాను సమయానికి చెల్లించకపోతే, కంపెనీ మా పై చట్టపరమైన చర్యలు తీసుకునే హక్కు కలిగి ఉంటుంది. దీనిపై నాకు ఎటువంటి అభ్యంతరం లేదు. </li>
            <li> మేము వాయిదాను సమయానికి చెల్లించకపోతే లేదా డిఫాల్టరైతే, కంపెనీ మా సిబిల్ రికార్డులో దీన్ని నమోదు చేసే హక్కు కలిగి ఉంటుంది. </li>
          </ol>
        </div>}

        {language === "hi" && <div className="page-break"></div>}

        {language === "hi" && <div className="section">
          <h2 className="title">नियम और शर्तें</h2>

          <ol style={{ fontSize: "14px" }}>
            <li>
              उपरोक्त सभी पक्ष निम्नलिखित सभी शर्तों व नियमों पर अपनी सहमति
              व्यक्त करते हैं कि ऋणधारी इस राशि का उपयोग माइक्रोफाइनेंस की
              नियमावली समझकर करेंगे तथा इस राशि या इसके किसी भी अंश का उपयोग
              अन्य किसी भी उद्देश्य की पूर्ति हेतु नहीं करेंगे जिसके लिए इसे
              स्वीकृत नहीं किया गया है। हम इसके लिए भी सहमति व्यक्त करते हैं कि
              यदि कंपनी को ऐसा कोई कारण मिलता है जो स्पष्ट करता है कि शर्तों की
              पालना नहीं की गई है, तो कंपनी को अधिकार है कि वह इस ऋण राशि या
              उसके अंश को बिना किसी रियायत के वापस ले ले।
            </li>
            <li>
              मैं/हम, लोन के लिए आवेदन करने वाले तथा गारंटर, पूर्व में किसी भी
              गैर-कानूनी कार्य में लिप्त नहीं हैं और न ही किसी न्यायालय में
              हमारे विरुद्ध आपराधिक मामला विचाराधीन है और न ही किसी भी थाने में
              कोई एफआईआर दर्ज है।
            </li>
            <li>
              यह है कि मैं/हम किसी वित्तीय संस्थान, बैंक या फाइनेंस कंपनी द्वारा
              डिफॉल्टर घोषित नहीं किए गए हैं।
            </li>
            <li>
              यह है कि मैं/हम उक्त लोन की संपूर्ण किस्तों का भुगतान करने में
              पूरी तरह से सक्षम हैं और किसी भी विपरीत परिस्थिति में मैं/हम
              भुगतान करने में देरी नहीं करेंगे।
            </li>
            <li>
              यह है कि कंपनी का जो भी कर्मचारी किस्त की राशि का संग्रहण करने
              आएगा, मैं उसके साथ विनम्र व्यवहार रखूंगा/रखेंगे एवं उसे किसी भी
              प्रकार की आपत्तिजनक बात नहीं कहूंगा/कहेंगे। किसी भी प्रकार का उसे
              नुकसान या मारपीट की कोशिश नहीं करेंगे और न ही उसके खिलाफ गंदे
              व्यवहार या अपशब्द बोलने का आरोप लगाएंगे। अगर हमारे द्वारा कोई भी
              अभद्र व्यवहार किया जाता है, तो कंपनी कर्मचारी तथा कंपनी हमारे
              प्रति कानूनी कार्रवाई करने के लिए स्वतंत्र होंगे।
            </li>
            <li>
              यह है कि मैं/हम, नियत तिथि की सूचना देने से संबंधित जानकारी अपनी
              किस्तों के संपूर्ण भुगतान के लिए नोटिस, रिमाइंडर व इलेक्ट्रॉनिक
              सूचना, फोन इत्यादि देने के लिए कंपनी जिम्मेदार नहीं होगी। इस बात
              की याददाश्त से संबंधित संपूर्ण जिम्मेदारी मेरी/हमारी होगी।
            </li>
            <li>
              यह है कि अगर ऋणी या गारंटर अपने व्यवसाय, नौकरी, मूल निवास, मोबाइल
              नंबर या ईमेल आईडी का परिवर्तन करता है, तो इस बात की सूचना कंपनी को
              पूर्व में लिखित रूप में प्रदान करेंगे।
            </li>
            <li>
              यह है कि मैं/हम यह वचनबद्ध बयान करते हैं कि भविष्य में यदि हमारे
              द्वारा किस्तों का भुगतान चेक के माध्यम से किया जाता है, तो हम दिए
              गए चेकों को बैंक में स्टॉप नहीं कराएंगे और न ही उक्त चेक के खोने
              की रिपोर्ट थाने में दर्ज कराएंगे और न ही उक्त खाते को बंद कराएंगे।
              यदि हम ऐसा करते हैं, तो कंपनी हमारे विरुद्ध कानूनी कार्रवाई करने
              का अधिकार रखेगी।
            </li>
            <li>
              यह है कि कंपनी द्वारा संग्रहण से संबंधित जो सुविधाएं जैसे कि
              एसएमएस, कॉलिंग, मेल, नोटिस प्रदान करने के लिए जो भी सर्विस चार्ज
              अलग से मांगा जाएगा, वह हम प्रदान करेंगे।
            </li>
            <li>
              यह है कि इस अनुबंध के अनुसार गारंटर की पूरी जिम्मेदारी और
              उत्तरदायित्व है। अगर भविष्य में आवेदक के साथ कोई आकस्मिक घटना,
              मृत्यु, दिवालिया या गंभीर बीमारी हो जाती है, तो संपूर्ण लोन का
              भुगतान गारंटर द्वारा किया जाएगा।
            </li>
            <li>
              यह है कि हम/मैं द्वारा कंपनी को दी गई संपूर्ण जानकारी मौखिक रूप से
              प्रदान की गई है, जो कि सत्य व सही है। इसमें किसी भी प्रकार का कोई
              झूठा तथ्य नहीं बताया गया है। यदि कोई जानकारी झूठी पाई जाती है, तो
              कंपनी हमारे विरुद्ध कानूनी कार्रवाई करने का अधिकार रखेगी। मैं/हम
              ने लोन के बारे में समस्त जानकारी जैसे ब्याज, किस्तों की राशि,
              किस्तों का समय और अदायगी का समय अच्छी तरह से समझ लिया है। कंपनी के
              कर्मचारी द्वारा मुझे संपूर्ण जानकारी दे दी गई है। उक्त सभी नियमों
              व शर्तों के लिए मैं/हम पूरी तरह तैयार हैं। अगर मैं/हम किस्त देने
              में देरी करते हैं, तो उस पर लगने वाला अतिरिक्त भार, लीगल खर्च,
              पेपर खर्च, विजिट खर्च और अन्य खर्च जो भी भविष्य में आएगा, वह हमारे
              द्वारा प्रदान किया जाएगा।
            </li>
            <li>
              यह है कि मैं/हम प्रस्तुत किए गए समस्त दस्तावेज जैसे कि आधार कार्ड,
              पैन कार्ड, राशन कार्ड, ड्राइविंग लाइसेंस, बैंक की पासबुक और फोटो
              के साथ किसी भी तरह की छेड़छाड़ या कोई भी फर्जी दस्तावेज प्रस्तुत
              नहीं किए गए हैं। निकट भविष्य में यदि किसी भी दस्तावेज के फर्जी पाए
              जाने पर हमारे खिलाफ 420 का मुकदमा कंपनी द्वारा किया जा सकता है, इस
              बात से हम पहले से अवगत हैं।
            </li>
            <li>
              यह है कि हम/मैं अपनी किस्तों का भुगतान
              दैनिक/साप्ताहिक/द्विसाप्ताहिक/मासिक रूप में करना चाहते हैं।
            </li>
            <li>
              यह है कि इस ऋण के भुगतान और उसके बकाया या किसी भी अंश की स्वीकृति
              या किसी भी अन्य विशेष कार्य हेतु जब भी कंपनी द्वारा बुलाया जाएगा,
              मैं/हम समय पर उपस्थित हो जाएंगे।
            </li>
            <li>
              यह है कि मेरी सालाना आय {countryCurrency}300000 से कम है। उक्त एग्रीमेंट या लोन को
              करते समय हमने किसी भी प्रकार का कोई नशा नहीं किया हुआ है। हम पूरे
              होशो हवास में यह एग्रीमेंट कर रहे हैं।
            </li>
            <li>
              हम यह वचनबद्ध बयान करते हैं कि भविष्य में यदि हमारे द्वारा किस्त
              समय पर नहीं जमा होगी, तो कंपनी हमारे विरुद्ध कानूनी कार्यवाही करने
              का अधिकार रखेगी। इससे मुझे कोई आपत्ति नहीं है।
            </li>
            <li>
              यदि हम अपनी किस्त समय से नहीं जमा करते हैं या डिफॉल्ट होने की
              स्थिति में, कंपनी सिबिल पर हमारा रिकॉर्ड दर्ज करने का अधिकार
              रखेगी।
            </li>
          </ol>
        </div>}

        {language === "ml" && <div className="page-break"></div>}

        {language === "ml" && <div className="section">
          <h2 className="title">നിബന്ധനകളും വ്യവസ്ഥകളും</h2>

          <ol style={{ fontSize: "14px" }}>
            <li> മുകളിൽ പറഞ്ഞിട്ടുള്ള എല്ലാ കക്ഷികളും താഴെപ്പറയുന്ന നിബന്ധനകളും വ്യവസ്ഥകളും അംഗീകരിക്കുന്നു. കടം വാങ്ങുന്ന വ്യക്തി ഈ തുക മൈക്രോഫൈനാൻസ് നിയമങ്ങൾ മനസ്സിലാക്കി മാത്രമേ ഉപയോഗിക്കൂ. അനുമതി നൽകിയിട്ടില്ലാത്ത മറ്റേതെങ്കിലും ആവശ്യത്തിനായി ഈ തുകയോ അതിലെ ഏത് ഭാഗമോ ഉപയോഗിക്കരുത്. വ്യവസ്ഥകൾ പാലിച്ചിട്ടില്ലെന്ന് കമ്പനി കണ്ടെത്തുന്നുവെങ്കിൽ, കമ്പനി ഈ കടത്തുകയോ അതിലെ ഏതെങ്കിലും ഭാഗമോ യാതൊരു ഇളവും കൂടാതെ തിരികെ വാങ്ങാനുള്ള അവകാശം കമ്പനിയ്ക്കുണ്ട്. </li>
            <li> ഞാൻ/ഞങ്ങൾ, കടം അപേക്ഷിക്കുന്നതും ഗാരന്റർ ആകുന്നതുമായ വ്യക്തികൾ, മുൻപ് യാതൊരു നിയമവിരുദ്ധ പ്രവൃത്തി ചെയ്തിട്ടില്ല. നമ്മുടെ പേരിൽ ഏതെങ്കിലും കോടതിയിൽ ക്രിമിനൽ കേസ് നിലനിൽക്കുന്നില്ല, പോലീസ് സ്റ്റേഷനിൽ എഫ്.ഐ.ആർ. രജിസ്റ്റർ ചെയ്തതുമില്ല. </li>
            <li> ഞാൻ/ഞങ്ങളെ ഏതെങ്കിലും ബാങ്ക്, ധനകാര്യ സ്ഥാപനം അല്ലെങ്കിൽ ഫിനാൻസ് കമ്പനി ഡിഫോൾട്ടറായി പ്രഖ്യാപിച്ചിട്ടില്ല. </li>
            <li> ഞാൻ/ഞങ്ങൾ ഈ കടത്തിന്റെ മുഴുവൻ ഇ.എം.ഐകൾ അടയ്ക്കാനുള്ള സമ്പൂർണ്ണ ശേഷിയുണ്ട്. ഏത് പ്രതിക്കൂല സാഹചര്യങ്ങളിലും ഞങ്ങൾ പണമടയ്ക്കുന്നതിൽ താമസിക്കില്ല. </li>
            <li> കമ്പനിയുടെ തുക ശേഖരിക്കാൻ വരുന്ന ഏത് ജീവനക്കാരോടും ഞാൻ/ഞങ്ങൾ വിനീതമായി പെരുമാറും. അവരോട് ഒരിക്കലും അസഭ്യവാക്കുകൾ പറയുകയോ മോശമായി പെരുമാറുകയോ ഇല്ല. അവരെ ഹാനികരമാക്കാൻ ശ്രമിക്കുകയോ അടിക്കുകയോ ഇല്ല. ഞങ്ങളുടെ ഭാഗത്ത് നിന്ന് ഒരു തെറ്റായ പെരുമാറ്റവും കാണിച്ചാൽ, കമ്പനിയും ജീവനക്കാരനും ഞങ്ങൾക്കെതിരെ നിയമനടപടി സ്വീകരിക്കാൻ സ്വതന്ത്രരാണ്. </li>
            <li> ഇ.എം.ഐകളുടെ തീയതി, റിമൈൻഡർ, നോട്ടീസ്, കോളുകൾ, ഇലക്ട്രോണിക് സന്ദേശങ്ങൾ എന്നിവ നൽകാൻ കമ്പനി ബാധ്യതയില്ല. ഇ.എം.ഐയുടെ തീയതി ഓർമ്മിക്കാൻ പൂർണ്ണ ഉത്തരവാദിത്വം ഞങ്ങളുടേതാണ്. </li>
            <li> കടം വാങ്ങുന്നയാൾ അല്ലെങ്കിൽ ഗാരന്റർ തങ്ങളുടെ ബിസിനസ്, ജോലി, സ്ഥിര വിലാസം, മൊബൈൽ നമ്പർ അല്ലെങ്കിൽ ഇമെയിൽ ഐഡി മാറ്റുകയാണെങ്കിൽ, അത് കമ്പനിയോട് മുൻകൂട്ടി എഴുത്തിൽ അറിയിക്കണം. </li>
            <li> ഭാവിയിൽ ഞങ്ങൾ ചെക്കിലൂടെ ഇ.എം.ഐ നൽകുന്നുവെങ്കിൽ, നൽകിയ ചെക്കുകൾ ബാങ്കിൽ സ്റ്റോപ്പ് ചെയ്യുകയോ, നഷ്ടപ്പെട്ടതായി റിപ്പോർട്ട് ചെയ്യുകയോ, ആ അക്കൗണ്ട് അടച്ചു പൂട്ടുകയോ ചെയ്യില്ല. അങ്ങനെ ചെയ്താൽ കമ്പനിയ്ക്ക് ഞങ്ങളെതിരെ നിയമനടപടി സ്വീകരിക്കാനുള്ള അവകാശമുണ്ട്. </li>
            <li> കമ്പനി ശേഖരണവുമായി ബന്ധപ്പെട്ട എസ്എംഎസ്, കോൾ, മെയിൽ, നോട്ടീസ് എന്നിവയ്ക്കായി ആവശ്യപ്പെടുന്ന സർവീസ് ചാർജ് ഞങ്ങൾ അടയ്ക്കും. </li>
            <li> ഈ കരാറനുസരിച്ച് ഗാരന്ററിന് പൂർണ്ണ ഉത്തരവാദിത്വവും ബാധ്യതയും ഉണ്ട്. ഭാവിയിൽ അപേക്ഷകനോട് അപകടം, മരണം, ദിവാളിത്തം, ഗുരുതര രോഗം എന്നിവ സംഭവിച്ചാൽ മുഴുവൻ കടവും ഗാരന്ററാണ് അടയ്ക്കേണ്ടത്. </li>
            <li> ഞാൻ/ഞങ്ങൾ കമ്പനിക്ക് നൽകിയ എല്ലാ വിവരങ്ങളും വാചാലമായി നൽകിയതും യഥാർത്ഥവും ശരിയുമാണ്. വ്യാജ വിവരമൊന്നും നൽകിയിട്ടില്ല. വ്യാജ വിവരം കണ്ടെത്തിയാൽ കമ്പനിക്ക് നിയമനടപടി സ്വീകരിക്കാൻ അവകാശമുണ്ട്. പലിശ, ഇ.എം.ഐ, അടവിന്റെ തീയതി എന്നിവർ എല്ലാം ഞങ്ങൾ മനസ്സിലാക്കി. കമ്പനിയുടെ ജീവനക്കാരൻ മുഴുവൻ വിശദാംശങ്ങളും ഞങ്ങളോട് വിശദീകരിച്ചു. ഈ വ്യവസ്ഥകൾ എല്ലാം ഞാൻ/ഞങ്ങൾ പൂർണ്ണമായി അംഗീകരിക്കുന്നു. ഇ.എം.ഐ അടയ്ക്കുന്നതിൽ താമസം സംഭവിച്ചാൽ, അധിക ചാർജ്, നിയമ ചിലവ്, പേപ്പർ ചിലവ്, സന്ദർശന ചിലവ് എന്നിവ എല്ലാം ഞങ്ങളാണ് അടയ്ക്കേണ്ടത്. </li>
            <li> ഞാൻ/ഞങ്ങൾ നൽകിയ ആധാർ കാർഡ്, പാൻ കാർഡ്, റേഷൻ കാർഡ്, ഡ്രൈവിംഗ് ലൈസൻസ്, ബാങ്ക് പാസ്‌ബുക്ക്, ഫോട്ടോ എന്നിവയിൽ യാതൊരു തരത്തിലുള്ള വ്യാജവുമില്ല. ഭാവിയിൽ ഏതെങ്കിലും ഡോക്യുമെന്റ് വ്യാജമാണെന്ന് കണ്ടെത്തുകയാണെങ്കിൽ, 420 വകുപ്പ് പ്രകാരം ഞങ്ങള്ക്കെതിരെ കേസ് ഫയൽ ചെയ്യാമെന്ന് ഞങ്ങൾ മുൻകൂട്ടി അറിയുന്നു. </li> <li> ഞാൻ/ഞങ്ങൾ ഞങ്ങളുടെ ഇ.എം.ഐകൾ ദിവസേന/വാരാന്ത്യ/ഇരുവാര/മാസാന്ത്യ അടിസ്ഥാനത്തിൽ അടയ്ക്കാൻ ആഗ്രഹിക്കുന്നു. </li>
            <li> ഈ കടം തിരിച്ചടക്കുന്നതിനും ബാക്കി തുകയ്ക്കുമായി കമ്പനി വിളിച്ചാൽ, ഞാൻ/ഞങ്ങൾ സമയത്ത് ഹാജരാകുമെന്ന് ഉറപ്പുനൽകുന്നു. </li>
            <li> എന്റെ വാർഷിക വരുമാനം {countryCurrency}300000-ൽ താഴെയാണ്. ഈ കരാർ ചെയ്യുമ്പോൾ ഞങ്ങൾ യാതൊരു മയക്കുമരുന്നോ ലഹരിപദാർത്ഥമോ ഉപയോഗിച്ചിരുന്നില്ല. പൂർണ്ണ ബോധവുമുള്ള നിലയിലും വ്യക്തമായ മനസ്സോടെയും ഈ കരാറിൽ ഒപ്പിടുന്നു. </li>
            <li> ഭാവിയിൽ ഞങ്ങൾ ഇ.എം.ഐ സമയം തെറ്റുകയും അടയ്ക്കാതിരിക്കുകയോ ചെയ്താൽ, കമ്പനി ഞങ്ങളെതിരെ നിയമനടപടി സ്വീകരിക്കാനുള്ള അവകാശമുണ്ട്. ഇതിൽ എനിക്ക് യാതൊരു എതിർപ്പുമില്ല. </li>
            <li> ഞങ്ങൾ ഇ.എം.ഐ സമയം തെറ്റിക്കുകയും അല്ലെങ്കിൽ ഡിഫോൾട്ടറാകുകയും ചെയ്താൽ, കമ്പനി ഞങ്ങളുടെ സിബിൽ റെക്കോർഡിൽ ഇതു രേഖപ്പെടുത്താനുള്ള അവകാശമുണ്ട്. </li>
          </ol>
        </div>}

        {language === "kn" && <div className="page-break"></div>}

        {language === "kn" && <div className="section">
          <h2 className="title">ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು</h2>

          <ol style={{ fontSize: "14px" }}>
            <li> ಮೇಲ್ಕಂಡ ಎಲ್ಲಾ ಪಕ್ಷಗಳು ಕೆಳಗಿನ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳಿಗೆ ತಮ್ಮ ಒಪ್ಪಿಗೆಯನ್ನು ವ್ಯಕ್ತಪಡಿಸುತ್ತಾರೆ. ಸಾಲಗಾರನು ಈ ಮೊತ್ತವನ್ನು ಮೈಕ್ರೋಫೈನಾನ್ಸ್ ನಿಯಮಾವಳಿಗಳನ್ನು ಮನಗಂಡು ಮಾತ್ರ ಬಳಸಬೇಕು. ಅನುಮತಿಸದೇ ಇರುವ ಯಾವುದೇ ಇತರ ಉದ್ದೇಶಗಳಿಗೆ ಈ ಮೊತ್ತವನ್ನು ಅಥವಾ ಅದರ ಯಾವುದೇ ಭಾಗವನ್ನು ಬಳಸಬಾರದು. ನಿಯಮಗಳನ್ನು ಪಾಲಿಸದಿರುವುದು ಕಂಪನಿಗೆ ತಿಳಿದರೆ, ಕಂಪನಿಗೆ ಈ ಸಾಲದ ಮೊತ್ತವನ್ನು ಅಥವಾ ಅದರ ಭಾಗವನ್ನು ಯಾವುದೇ ರಿಯಾಯಿತಿ ಇಲ್ಲದೆ ಹಿಂತೆಗೆದುಕೊಳ್ಳುವ ಹಕ್ಕು ಇದೆ. </li>
            <li> ನಾನು/ನಾವು, ಸಾಲಕ್ಕಾಗಿ ಅರ್ಜಿ ಸಲ್ಲಿಸುವವರು ಹಾಗೂ ಜಾಮೀನುದಾರರು, ಹಿಂದೆ ಯಾವುದೇ ಕಾನೂನುಬಾಹಿರ ಕಾರ್ಯಗಳಲ್ಲಿ ತೊಡಗಿಲ್ಲ. ನಮ್ಮ ವಿರುದ್ಧ ಯಾವುದೇ ನ್ಯಾಯಾಲಯದಲ್ಲಿ ಅಪರಾಧ ಪ್ರಕರಣ ಬಾಕಿಯಿಲ್ಲ, ಪೊಲೀಸ್ ಠಾಣೆಯಲ್ಲಿ ಎಫ್‌ಐಆರ್ ದಾಖಲಾಗಿಲ್ಲ. </li>
            <li> ನಾನು/ನಾವು ಯಾವುದೇ ಹಣಕಾಸು ಸಂಸ್ಥೆ, ಬ್ಯಾಂಕ್ ಅಥವಾ ಫೈನಾನ್ಸ್ ಕಂಪನಿಯವರಿಂದ ಡಿಫಾಲ್ಟರ್ ಎಂದು ಘೋಷಿಸಲ್ಪಟ್ಟಿಲ್ಲ. </li>
            <li> ನಾನು/ನಾವು ಈ ಸಾಲದ ಎಲ್ಲಾ ಕಂತುಗಳನ್ನು ಪಾವತಿಸಲು ಸಂಪೂರ್ಣ ತಕ್ಷಣ್ಯವನ್ನು ಹೊಂದಿದ್ದೇವೆ. ಯಾವ ರೀತಿಯ ಪ್ರತಿಕೂಲ ಸಂದರ್ಭಗಳಲ್ಲಿಯೂ ಪಾವತಿಯನ್ನು ತಡ ಮಾಡುವುದಿಲ್ಲ. </li>
            <li> ಕಂತುಗಳನ್ನು ಸಂಗ್ರಹಿಸಲು ಬರುವ ಕಂಪನಿಯ ಸಿಬ್ಬಂದಿಗಳೊಂದಿಗೆ ನಾನು/ನಾವು ಶಿಷ್ಟವಾಗಿ ವರ್ತಿಸುತ್ತೇವೆ. ಅವರಿಗೆ ಯಾವುದೇ ರೀತಿಯ ಅವಾಚ್ಯ ಪದಗಳನ್ನು ಬಳಸುವುದಿಲ್ಲ, ಹಾನಿ ಮಾಡುವ ಪ್ರಯತ್ನ ಮಾಡುವುದಿಲ್ಲ. ನಮ್ಮಿಂದ ಯಾವುದೇ ಅಸಭ್ಯ ವರ್ತನೆ ನಡೆದರೆ, ಕಂಪನಿ ಮತ್ತು ಸಿಬ್ಬಂದಿಗೆ ನಮ್ಮ ವಿರುದ್ಧ ಕಾನೂನು ಕ್ರಮ ಕೈಗೊಳ್ಳುವ ಸಂಪೂರ್ಣ ಹಕ್ಕು ಇದೆ. </li>
            <li> ಕಂತುಗಳ ನಿಗದಿತ ದಿನಾಂಕವನ್ನು ಸ್ಮರಿಸಲು ನೋಟಿಸ್, ರಿಮೈಂಡರ್, ಎಲೆಕ್ಟ್ರಾನಿಕ್ ಸಂದೇಶಗಳು, ಫೋನ್ ಕರೆಗಳು ನೀಡುವ ಜವಾಬ್ದಾರಿ ಕಂಪನಿಯದ್ದು ಅಲ್ಲ. ಕಂತಿನ ದಿನಾಂಕವನ್ನು ನೆನಪಿಟ್ಟುಕೊಳ್ಳುವ ಸಂಪೂರ್ಣ ಜವಾಬ್ದಾರಿ ನನ್ನದು/ನಮ್ಮದು. </li>
            <li> ಸಾಲಗಾರ ಅಥವಾ ಜಾಮೀನುದಾರ ತಮ್ಮ ಉದ್ಯೋಗ, ವ್ಯಾಪಾರ, ಶಾಶ್ವತ ವಿಳಾಸ, ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ಅಥವಾ ಇಮೇಲ್ ಐಡಿ ಬದಲಿಸಿದರೆ, ಅದರ ಬಗ್ಗೆ ಕಂಪನಿಗೆ ಪೂರ್ವದಲ್ಲೇ ಲಿಖಿತವಾಗಿ ಮಾಹಿತಿ ನೀಡಬೇಕು. </li>
            <li> ಭವಿಷ್ಯದಲ್ಲಿ ನಾನು/ನಾವು ಚೆಕ್ ಮೂಲಕ ಕಂತುಗಳನ್ನು ಪಾವತಿಸಿದರೆ, ನೀಡಿದ ಚೆಕ್‌ಗಳನ್ನು ಬ್ಯಾಂಕಿನಲ್ಲಿ ಸ್ಟಾಪ್ ಮಾಡುವುದಿಲ್ಲ, ಅವು ಕಳೆದುಹೋಯಿತೆಂದು ದೂರಿನಲ್ಲಿ ಹೇಳುವುದಿಲ್ಲ, ಅಥವಾ ಅದರ ಬ್ಯಾಂಕ್ ಖಾತೆಯನ್ನು ಮುಚ್ಚುವುದಿಲ್ಲ. ಹೀಗೆ ಮಾಡಿದರೆ ಕಂಪನಿಗೆ ನಮ್ಮ ವಿರುದ್ಧ ಕಾನೂನು ಕ್ರಮ ಕೈಗೊಳ್ಳುವ ಹಕ್ಕಿದೆ. </li>
            <li> ಕಂತು ಸಂಗ್ರಹಣೆಗಾಗಿ ಕಂಪನಿ ಒದಗಿಸುವ SMS, ಕರೆ, ಮೇಲ್, ನೋಟಿಸ್ ಮೊದಲಾದ ಸೇವೆಗಳಿಗಾಗಿ ಕೇಳುವ ಯಾವುದೇ ಸೇವಾ ಶುಲ್ಕವನ್ನು ನಾನು/ನಾವು ಪಾವತಿಸುತ್ತೇವೆ. </li>
            <li> ಈ ಒಪ್ಪಂದದ ಪ್ರಕಾರ ಜಾಮೀನುದಾರನು ಪೂರ್ಣ ಹೊಣೆಗಾರಿಕೆಯನ್ನು ಹೊಂದಿರುತ್ತಾನೆ. ಭವಿಷ್ಯದಲ್ಲಿ ಸಾಲಗಾರನಿಗೆ ಅಪಘಾತ, ಮರಣ, ದಿವಾಳಿತನ ಅಥವಾ ಗಂಭೀರ ಅನಾರೋಗ್ಯ ಉಂಟಾದರೆ, ಸಂಪೂರ್ಣ ಸಾಲವನ್ನು ಜಾಮೀನುದಾರರು ಪಾವತಿಸಬೇಕು. </li>
            <li> ನಾನು/ನಾವು ಕಂಪನಿಗೆ ನೀಡಿದ ಎಲ್ಲಾ ಮಾಹಿತಿಗಳು ನಿಖರವಾಗಿವೆ, ಯಾವುದೇ ಸುಳ್ಳು ಮಾಹಿತಿ ನೀಡಿಲ್ಲ. ತಪ್ಪು ಮಾಹಿತಿ ಕಂಡುಬಂದಲ್ಲಿ ಕಂಪನಿಗೆ ನಮ್ಮ ವಿರುದ್ಧ ಕಾನೂನು ಕ್ರಮ ಕೈಗೊಳ್ಳುವ ಹಕ್ಕಿದೆ. ಬಡ್ಡಿ, ಕಂತು ಮೊತ್ತ, ಕಂತುಗಳ ಅವಧಿ ಇತ್ಯಾದಿ ಬಗ್ಗೆ ನಾನು/ನಾವು ಸಂಪೂರ್ಣವಾಗಿ ತಿಳಿದುಕೊಂಡಿದ್ದೇವೆ. ಕಂಪನಿಯ ಸಿಬ್ಬಂದಿಗಳು ಎಲ್ಲಾ ಮಾಹಿತಿಯನ್ನು ನಮಗೆ ವಿವರಿಸಿದ್ದಾರೆ. ಈ ಎಲ್ಲಾ ಷರತ್ತುಗಳನ್ನು ನಾನು/ನಾವು ಸಂಪೂರ್ಣವಾಗಿ ಒಪ್ಪುತ್ತೇವೆ. ಕಂತು ಪಾವತಿಯಲ್ಲಿ ತಡವಾದರೆ, ಹೆಚ್ಚುವರಿ ಶುಲ್ಕ, ಕಾನೂನು ವೆಚ್ಚ, ಕಾಗದ ವೆಚ್ಚ, ಭೇಟಿ ವೆಚ್ಚ ಮೊದಲಾದವೆಲ್ಲವನ್ನು ನಾವು ಪಾವತಿಸುತ್ತೇವೆ. </li>
            <li> ನಾನು/ನಾವು ನೀಡಿದ ಆಧಾರ್ ಕಾರ್ಡ್, ಪ್ಯಾನ್ ಕಾರ್ಡ್, ರೇಷನ್ ಕಾರ್ಡ್, ಚಾಲನಾ ಪರವಾನಗಿ, ಬ್ಯಾಂಕ್ ಪಾಸ್‌ಬುಕ್ ಮತ್ತು ಫೋಟೋಗಳಲ್ಲಿ ಯಾವುದೇ ತಿದ್ದುಪಡಿ ಅಥವಾ ನಕಲಿ ದಾಖಲೆಗಳನ್ನು ಸಲ್ಲಿಸಲಾಗಿಲ್ಲ. ಭವಿಷ್ಯದಲ್ಲಿ ಯಾವ ದಾಖಲೆ ನಕಲಿ ಎಂದು ಕಂಡುಬಂದರೂ, ಕಂಪನಿ 420ರ ಸೆಕ್ಷನ್ ಪ್ರಕಾರ ನಮ್ಮ ವಿರುದ್ಧ ಪ್ರಕರಣ ದಾಖಲಿಸಬಹುದು ಎಂಬುದನ್ನು ನಾವು ಈಗಾಗಲೇ ತಿಳಿದುಕೊಂಡಿದ್ದೇವೆ. </li>
            <li> ನಾನು/ನಾವು ನಮ್ಮ ಕಂತುಗಳನ್ನು ದಿನನಿತ್ಯ/ವಾರದ/ಪಕ್ಷವಾರ/ಮಾಸಿಕವಾಗಿ ಪಾವತಿಸಲು ಇಷ್ಟಪಡುತ್ತೇವೆ. </li>
            <li> ಈ ಸಾಲದ ಪಾವತಿ, ಬಾಕಿ ಮೊತ್ತ, ಅಥವಾ ಕಂಪನಿ ವಿಶೇಷವಾಗಿ ಕರೆಸಿದ ಯಾವುದೇ ಕೆಲಸಕ್ಕಾಗಿ, ನಾನು/ನಾವು ಸಮಯಕ್ಕೆ ತಕ್ಕಂತೆ ಹಾಜರಾಗುತ್ತೇವೆ. </li>
            <li> ನನ್ನ ವಾರ್ಷಿಕ ಆದಾಯ {countryCurrency}300000 ಕ್ಕಿಂತ ಕಡಿಮೆ. ಈ ಒಪ್ಪಂದ ಮಾಡುವ ಸಮಯದಲ್ಲಿ ನಾವು ಯಾವುದೇ ಮಾದಕ ಪದಾರ್ಥಗಳನ್ನು ಸೇವಿಸಿಲ್ಲ. ಸಂಪೂರ್ಣ ಹಿತಚಿಂತನೆ ಮತ್ತು ಜಾಗೃತ ಮನಸ್ಸಿನಿಂದ ಈ ಒಪ್ಪಂದ ಮಾಡುತ್ತಿದ್ದೇವೆ. </li>
            <li> ಭವಿಷ್ಯದಲ್ಲಿ ನಾನು/ನಾವು ಕಂತುಗಳನ್ನು ಸಮಯಕ್ಕೆ ಪಾವತಿಸದಿದ್ದರೆ, ಕಂಪನಿಗೆ ನಮ್ಮ ವಿರುದ್ಧ ಕಾನೂನು ಕ್ರಮ ಕೈಗೊಳ್ಳುವ ಹಕ್ಕಿದೆ. ಇದಕ್ಕೆ ನನಗೆ/ನಮಗೆ ಯಾವುದೇ ಆಕ್ಷೇಪವಿಲ್ಲ. </li>
            <li> ನಾವು ಕಂತುಗಳನ್ನು ಸರಿಯಾದ ಸಮಯಕ್ಕೆ ಪಾವತಿಸದಿದ್ದರೆ ಅಥವಾ ಡಿಫಾಲ್ಟರಾಗಿದ್ದರೆ, ನಮ್ಮ ಸಿಬಿಲ್ ದಾಖಲೆಗಳಲ್ಲಿ ಇದನ್ನು ದಾಖಲಿಸುವ ಹಕ್ಕು ಕಂಪನಿಗಿದೆ. </li>
          </ol>
        </div>}

        {language === "mr" && <div className="page-break"></div>}

        {language === "mr" && <div className="section">
          <h2 className="title">अटी व शर्ती</h2>

          <ol style={{ fontSize: "14px" }}>
            <li>वरील सर्व पक्ष खालील सर्व अटी व नियम मान्य करतात की कर्जदार हा रक्कम मायक्रोफायनान्सच्या नियमावलीनुसार वापरेल आणि ही रक्कम किंवा तिचा कोणताही भाग इतर कोणत्याही उद्देशासाठी वापरला जाणार नाही ज्यासाठी ती मंजूर केलेली नाही. आम्ही यासाठी देखील सहमती देतो की जर कंपनीला असे काही कारण सापडले ज्यामुळे स्पष्ट होते की अटींचे पालन केले गेले नाही, तर कंपनीला हा कर्ज रक्कम किंवा त्याचा काही भाग कोणत्याही सवलतीशिवाय परत घेण्याचा अधिकार असेल.</li>
            <li>
              मी/आम्ही, कर्जासाठी अर्ज करणारे व हमीदार, पूर्वी कोणत्याही बेकायदेशीर कामात गुंतलेले नाही आणि कोणत्याही न्यायालयात आमच्याविरुद्ध आपराधिक प्रकरण चालू नाही तसेच कोणत्याही पोलीस स्टेशनमध्ये एफआयआर नोंदणीकृत नाही.
            </li>
            <li>
              मी/आम्ही कोणत्याही वित्तीय संस्था, बँक किंवा फायनान्स कंपनीकडून डिफॉल्टर घोषित केलेले नाही.
            </li>
            <li>
              मी/आम्ही सदर कर्जाच्या सर्व हप्त्यांचे भरणे करण्यास पूर्ण सक्षम आहोत आणि कोणत्याही विपरीत परिस्थितीत आम्ही हप्त्यांचे भरणे उशिरा करणार नाही.
            </li>
            <li>
              कंपनीचा कोणताही कर्मचारी हप्त्याची रक्कम गोळा करण्यासाठी आला, तर मी/आम्ही त्याच्याशी नम्रतेने वागू आणि त्याला कोणताही त्रास किंवा अपमान करू नाही. जर आमच्या वतीने काहीही अशिष्ट वर्तन झाले, तर कंपनी आणि कर्मचारी आमच्याविरुद्ध कायदेशीर कारवाई करण्यास मोकळे राहतील.
            </li>
            <li>
              नियत तारखेची सूचना देण्याबाबत, हप्त्यांच्या संपूर्ण भरण्यासाठी नोटीस, रिमाइंडर व इलेक्ट्रॉनिक माहिती, फोन इत्यादी देण्याची जबाबदारी कंपनीवर नाही. या बाबतीतची सर्व स्मरणशक्ती माझी/आमची असेल.
            </li>
            <li>
              जर कर्जदार किंवा हमीदार आपला व्यवसाय, नोकरी, स्थायी पत्ता, मोबाइल नंबर किंवा ईमेल आयडी बदलत असेल, तर कंपनीला पूर्वी लिहीित स्वरूपात माहिती द्यावी.
            </li>
            <li>
              मी/आम्ही वचन देतो की भविष्यात जर हप्त्यांचे भरणे चेकद्वारे केले गेले, तर दिलेल्या चेक्स बँकेत थांबवले जाणार नाहीत, हरवलेले असल्याची तक्रार पोलीस स्टेशनमध्ये नोंदवली जाणार नाही आणि खाते बंद केले जाणार नाही. जर तसे केले, तर कंपनीला आमच्याविरुद्ध कायदेशीर कारवाई करण्याचा अधिकार असेल.
            </li>
            <li>
              कंपनीद्वारे वसुलीसाठी दिल्या जाणाऱ्या सुविधा जसे की SMS, कॉलिंग, मेल, नोटीस यासाठी आवश्यक असलेला सर्विस चार्ज आम्ही प्रदान करू.
            </li>
            <li>
              या करारानुसार हमीदाराची पूर्ण जबाबदारी आहे. भविष्यात अर्जदारास कोणताही अपघात, मृत्यू, दिवाळखोरी किंवा गंभीर आजार झाला, तर संपूर्ण कर्ज हमीदाराने भरणे आवश्यक आहे.
            </li>
            <li>
              आम्ही/मी कंपनीला दिलेली सर्व माहिती खरी आहे. कोणतीही चुकीची माहिती दिलेली नाही. जर चुकीची माहिती आढळली, तर कंपनीला आमच्याविरुद्ध कायदेशीर कारवाई करण्याचा अधिकार असेल. आम्ही कर्जावरील सर्व माहिती जसे की व्याज, हप्त्याची रक्कम, हप्त्यांची वेळ आणि भरण्याचा वेळ नीट समजली आहे.
            </li>
            <li>
              आम्ही/मी दिलेली सर्व कागदपत्रे जसे की आधार कार्ड, पॅन कार्ड, रेशन कार्ड, ड्रायव्हिंग लायसन्स, बँक पासबुक व फोटो कोणत्याही प्रकारे छेडछाड किंवा खोट्या दस्तऐवजांसह सादर केलेले नाहीत. भविष्यात कोणतेही दस्तऐवज खोटे आढळल्यास कंपनी 420 कलमान्वये आमच्याविरुद्ध खटला दाखल करू शकेल.
            </li>
            <li>
              आम्ही/मी हप्ते दैनिक/साप्ताहिक/द्विसाप्ताहिक/मासिक पद्धतीने भरण्याची इच्छा व्यक्त करतो.
            </li>
            <li>
              कर्ज भरण्यासाठी किंवा उर्वरित रक्कम किंवा अन्य विशेष कामासाठी कंपनी कॉल केल्यास आम्ही वेळेत उपस्थित राहू.
            </li>
            <li>
              माझी वार्षिक उत्पन्न {countryCurrency}300000 पेक्षा कमी आहे. हा करार करताना आम्ही कोणत्याही मद्यपान किंवा नशा केलेली नाही. आम्ही पूर्ण होशियारपणे हा करार करत आहोत.
            </li>
            <li>
              भविष्यात हप्ते वेळेवर जमा न झाल्यास कंपनी आमच्याविरुद्ध कायदेशीर कारवाई करण्याचा अधिकार ठेवेल. याबद्दल मला/आम्हाला काहीही आक्षेप नाही.
            </li>
            <li>
              जर हप्ते वेळेत जमा नाही झाले किंवा डिफॉल्ट झाल्यास, कंपनीला आमचे सिबिल रेकॉर्ड नोंदवण्याचा अधिकार असेल.
            </li>
          </ol>
        </div>}

            {language === "gu" && <div className="page-break"></div>}

            {language === "gu" && <div className="section">
              <h2 className="title">નિયમો અને શરતો</h2>

              <ol style={{ fontSize: "14px" }}>
                <li>ઉપરોક્ત તમામ પક્ષો નીચે દર્શાવેલ નિયમો અને શરતો માટે પોતાની સંમતિ આપે છે. લેણદાર આ લોન રકમનો ઉપયોગ માઇક્રોફાઇનાન્સના નિયમોને સમજીને જ કરશે. આ રકમ અથવા તેની કોઈપણ ભાગનો અન્ય અનધિકૃત હેતુ માટે ઉપયોગ નહીં કરે. જો કંપનીને લાગે કે શરતોનું પાલન કરવામાં આવ્યું નથી, તો કંપની કોઈપણ રાહત વિના સંપૂર્ણ લોન રકમ અથવા તેની કોઈપણ ભાગ પરત વસૂલ કરવાનો અધિકાર ધરાવે છે.</li>
                <li>હું/અમે, લોન માટે અરજી કરનાર અને જામીનદાર, અગાઉ કોઈ ગેરકાયદેસર પ્રવૃત્તિમાં સંકળાયેલા નથી. અમારી સામે કોઈ કોર્ટમાં ગુનાહિત કેસ બાકી નથી અને કોઈ પોલીસ સ્ટેશનમાં અમારા વિરુદ્ધ FIR નોંધાયેલ નથી.</li>
                <li>હું/અમે કોઈ બેંક, નાણાકીય સંસ્થા અથવા ફાઇનાન્સ કંપની દ્વારા ડિફોલ્ટર જાહેર કરવામાં આવ્યા નથી.</li>
                <li>હું/અમે આ લોનની તમામ કિસ્તો ચૂકવવા સક્ષમ છીએ. કોઈપણ પરિસ્થિતિમાં કિસ્ત ચૂકવવામાં વિલંબ નહીં કરીએ.</li>
                <li>કંપનીનો જે પણ કર્મચારી કિસ્ત વસૂલ કરવા આવે, તેમની સાથે હું/અમે સન્માનપૂર્વક વર્તન રાખીશું. કોઈ અપમાનજનક ભાષાનો ઉપયોગ નહીં કરીએ. તેમને નુકસાન પહોંચાડવાનો અથવા મારપીટ કરવાનો પ્રયાસ નહીં કરીએ. જો અમારાથી કોઈ ગેરવર્તન થશે, તો કર્મચારી અને કંપની અમારી સામે કાનૂની કાર્યવાહી કરી શકશે.</li>
                <li>કિસ્ત સંબંધિત યાદ અપાવવું, નોટિસ, રીમાઇન્ડર અથવા ઇલેક્ટ્રોનિક માહિતી આપવા કંપની જવાબદાર નહીં હોય. કિસ્તની તારીખ યાદ રાખવાની સંપૂર્ણ જવાબદારી મારી/અમારી રહેશે.</li>
                <li>લેણદાર અથવા જામીનદાર પોતાના વ્યવસાય, નોકરી, સરનામું, મોબાઇલ નંબર અથવા ઈમેલ આઈડીમાં ફેરફાર કરે તો તે પૂર્વલિખિત રીતે કંપનીને જાણ કરશે.</li>
                <li>ભવિષ્યમાં જો અમે ચેક દ્વારા કિસ્ત ચૂકવીએ, તો આપેલા ચેકની ચુકવણી બેંકમાં રોકીશું નહીં, ચેક ગુમ થયાની ફરિયાદ નહીં કરીએ અથવા બેંક ખાતું બંધ નહીં કરીએ. આવું કરવાથી કંપની અમારી સામે કાનૂની કાર્યવાહી કરી શકશે.</li>
                <li>કંપની દ્વારા SMS, કોલ, મેલ, નોટિસ જેવી સેવાઓ માટે જો કોઈ સર્વિસ ચાર્જ લાગુ પડે, તો અમે તે ચૂકવવા સંમત છીએ.</li>
                <li>આ કરાર મુજબ જામીનદાર સંપૂર્ણ જવાબદાર રહેશે. ભવિષ્યમાં લેણદારને અકસ્માત, મૃત્યુ, દિવાળિયાપણું અથવા ગંભીર બિમારી થાય તો સંપૂર્ણ લોન જામીનદાર ચૂકવશે.</li>
                <li>કંપનીને આપવામાં આવેલી તમામ માહિતી સત્ય અને સાચી છે. કોઈ ખોટી માહિતી આપવામાં આવી નથી. જો ખોટી માહિતી સાબિત થશે તો કંપની કાનૂની કાર્યવાહી કરી શકશે. વ્યાજદર, કિસ્ત રકમ, ચુકવણી સમય અને પદ્ધતિ અંગે અમને સંપૂર્ણ સમજ આપવામાં આવી છે. અમે તમામ નિયમો અને શરતો માટે સંપૂર્ણ તૈયાર છીએ. કિસ્ત મોડે ચૂકવીએ તો વધારાના ચાર્જ, કાનૂની ખર્ચ, દસ્તાવેજ ખર્ચ, મુલાકાત ખર્ચ વગેરે અમે ચૂકવીશું.</li>
                <li>અમારી દ્વારા આપવામાં આવેલ આધાર કાર્ડ, પાન કાર્ડ, રેશન કાર્ડ, ડ્રાઇવિંગ લાઇસન્સ, બેંક પાસબુક અને ફોટોગ્રાફ સહિતના તમામ દસ્તાવેજોમાં કોઈ ફેરફાર કરવામાં આવ્યો નથી અને કોઈ ખોટા દસ્તાવેજો આપવામાં આવ્યા નથી. જો ભવિષ્યમાં કોઈ દસ્તાવેજ ખોટો સાબિત થાય, તો અમારી સામે કલમ 420 હેઠળ કેસ થઈ શકે છે, તેની અમને જાણ છે.</li>
                <li>હું/અમે અમારી કિસ્તો દૈનિક/સાપ્તાહિક/પખવાડિયે/માસિક રીતે ચૂકવવા ઇચ્છીએ છીએ.</li>
                <li>આ લોનની ચુકવણી, બાકી રકમ અથવા અન્ય કોઈ ખાસ હેતુ માટે કંપની દ્વારા બોલાવવામાં આવે ત્યારે હું/અમે સમયસર હાજર રહીશું.</li>
                <li>મારી વાર્ષિક આવક {countryCurrency}3,00,000 કરતાં ઓછી છે. આ કરાર કરતી વખતે અમે કોઈપણ નશીલા પદાર્થનું સેવન કર્યું નથી. સંપૂર્ણ સચેત અને સમજીને આ કરાર કરીએ છીએ.</li>
                <li>ભવિષ્યમાં જો અમે કિસ્ત સમયસર ચૂકવવામાં નિષ્ફળ જઈએ, તો કંપની અમારી સામે કાનૂની કાર્યવાહી કરી શકે છે અને અમને કોઈ વાંધો નહીં હોય.</li>
                <li>જો અમે કિસ્ત સમયસર ચૂકવીએ નહીં અથવા ડિફોલ્ટ થઈએ, તો કંપનીને અમારી માહિતી CIBIL માં નોંધવાનો અધિકાર રહેશે.</li>
          </ol>
        </div>}
      </>
    )}

        {/* New page break */}
        <div className="page-break"></div>

        <div className="section">
          <h2 className="title">Terms and Conditions</h2>

          <ol>
            <li>
              All the above parties agree to all the following terms and
              conditions: the borrower will use this amount as per the rules of
              microfinance and will not use this amount or any part of it for
              any other purpose. We also agree that if the company finds any
              reason to believe that the terms have not been complied with, the
              company has the right to withdraw this loan amount or part thereof
              without any concession.
            </li>
            <li>
              My guarantor and I have not been involved in any illegal acts in
              the past, nor is there any criminal case pending against us in any
              court, nor is any {countryCode == '91' ? "FIR" : "complaint report"} registered against us in any police station.
            </li>
            <li>
              I/We are not burdened with any kind of loan from any financial
              institution, bank, or finance company, nor have I/We been declared
              a defaulter by any financial institution, bank, or finance
              company.
            </li>
            <li>
              I/We are fully capable of paying the entire installments of the
              said loan and I/We shall not delay the payment under any
              circumstances.
            </li>
            <li>
              I/We agree that whichever employee of the company comes to collect
              the installment amount, I will treat them politely and will not
              use any objectionable language, nor will I attempt to harm or beat
              them in any way, nor will I make false allegations or use abusive
              language. If any abusive behavior is exhibited by us, the company
              will be free to take legal action against us.
            </li>
            <li>
              I/We acknowledge that the company will not be responsible for
              sending notices, reminders, or electronic notifications (phone,
              etc.) for the payment of my installments. The entire
              responsibility related to the due date of payment of the loan will
              be mine/ours.
            </li>
            <li>
              If the Borrower(s) or the Guarantor(s) change their business, job,
              domicile, mobile number, or email ID, they shall give prior
              written notice to the company.
            </li>
            <li>
              I/We undertake that if future installments are paid by us through
              cheque, we will not stop payment of the cheques given to the bank,
              nor report the loss of the said cheque to the police station, nor
              close that account. If we do so, the company will have the right
              to take legal action against us.
            </li>
            <li>
              During the Company's storage-related facilities, such as SMS, we
              will provide the additional service charge required for providing
              the calling and email notice.
            </li>
            <li>
              The guarantor is fully responsible and liable as per this
              agreement. If any accidental event, death, insolvency, or serious
              illness occurs to the applicant in the future, the entire loan
              shall be paid by the guarantor.
            </li>
            <li>
              All the information provided by me/us to the company has been
              given truthfully and accurately, with no false statements. If any
              information is found to be false, the company has the right to
              take legal action against us. I/We have received complete
              information about the loan, such as the amount of interest,
              installment, and the time of repayment, from the company’s
              employee. We are fully prepared for all the above terms and
              conditions, and if we delay in paying the installments, we will
              bear the additional burden of legal expenses and other costs that
              may arise in the future.
            </li>
            {countryCode == '91' ? <li>
              All the documents submitted by me/us, such as Aadhar card, PAN
              card, ration card, driving license, bank passbook, and photo, have
              not been tampered with, nor have we submitted any fake documents.
              If any document is found to be forged, we are aware that the
              company can sue us under Section 420.
            </li> : <li>All documents and information submitted by me/us, including but not limited to government-issued identification, proof of address, financial documents, and photographs, are genuine and have not been tampered with. We confirm that no forged or fraudulent documents have been provided. We understand that if any document is found to be false or misleading, the Company reserves the right to take legal action against us in accordance with the applicable laws of the jurisdiction.</li>}
            <li>
              I/We wish to pay our installments daily/ten_daily/weekly/biweekly/monthly
              (as agreed upon).
            </li>
            <li>
              I/We shall be present in time as and when called for by the
              company for the payment of this loan, acceptance of arrears or any
              part thereof, or for any other specified purpose.
            </li>
            <li>
              My annual income is less than 300,000/-. We have not consumed any
              intoxicants while entering into this agreement or loan, and we are
              doing so in full consciousness.
            </li>
            <li>
              I/We undertake that in the future, if I/We do not deposit the
              installments on time, the company will have the right to take
              legal action against me/us. I/We have no objection to this.
            </li>
            <li>
              If I/We do not deposit my/our installment on time or in case of
              default, the company will have the right to report my/our record
              to {countryCode == '91' ? "CIBIL" : "any recognized credit bureau / credit reporting agency"}.
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};

LoanAgreement.prototype = {
  data: Proptypes.any,
  printRef: Proptypes.any,
};
